import { CreateTrainingPermissionsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const usecCreateTrainingPermissions = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { data, loading } = useQuery(CreateTrainingPermissionsDocument)

  return {
    loading,
    canCreate: !!data?.trainings._policies.trainingCreate.can,
  }
}
